import { ref, type Ref } from 'vue';
import { Conversation } from '@/modules/messenger/_modules/conversation/models/Conversation';

export const unreadConversations: Ref<Conversation[]> = ref([]);
